var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1666 28.1263H34.375L36.4583 19.793H29.1666V15.6263C29.1666 13.4805 29.1666 11.4596 33.3333 11.4596H36.4583V4.45964C35.7791 4.37005 33.2146 4.16797 30.5062 4.16797C24.85 4.16797 20.8333 7.62005 20.8333 13.9596V19.793H14.5833V28.1263H20.8333V45.8346H29.1666V28.1263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.de3c6cf9006336f38bb5b891d1fd2dc7.svg";
export { ForwardRef as ReactComponent };